import { effect, Signal, WritableSignal } from '@angular/core';

/**
 * Update the target signal whenever the input updates, except for when it is undefined.
 *
 * This works equivalently to a setter with @Input().
 */
export function trackInput<T>(inputSignal: Signal<T | undefined>, target: WritableSignal<T>) {
  return effect(() => {
    const value = inputSignal();
    if (value !== undefined) {
      target.set(value);
    }
  });
}

export function trackInputInclusiveUndefined<T>(
  inputSignal: Signal<T | undefined>,
  target: WritableSignal<T | undefined>,
) {
  return effect(() => {
    const value = inputSignal();
    target.set(value);
  });
}
